module.exports = __webpack_public_path__ + "media/images/delete_button-01df8fe83fd9eb3fbafc92ae884a947f.png";